export enum StatusEnum {
  NULL,
  WARNING,
  ERROR,
  SUCCESS,
}
